import { Grid } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { VesselVisitBerthAndTimingFormStore } from '@planning/pages/VesselVisit/Stores/VesselVisitBerthAndTimingFormStore'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { BerthSelector } from './BerthSelector'
import { QuayMeterMarkingsFields } from './QuayMeterMarkingsFields'
import { TimingsFields } from './TimingFields'
import { VesselFields } from './VesselFields'
import { VisitTypeSelector } from './VisitTypeSelector'

export interface IVesselVisitBerthAndTimingSubFormProps {
  store: VesselVisitBerthAndTimingFormStore
  berthPlanningViewStore: BerthPlanningViewStore
  hideTypeSelector?: boolean
}

export const VesselVisitBerthAndTimingSubForm: FC<IVesselVisitBerthAndTimingSubFormProps> =
  observer(({ store, berthPlanningViewStore, hideTypeSelector = false }) => {
    return (
      <Grid container spacing={2}>
        <TimingsFields store={store} />

        {!hideTypeSelector && <VisitTypeSelector store={store} />}

        <VesselFields store={store} berthPlanningViewStore={berthPlanningViewStore} />

        <BerthSelector store={store} berthPlanningViewStore={berthPlanningViewStore} />

        <QuayMeterMarkingsFields store={store} berthPlanningViewStore={berthPlanningViewStore} />
      </Grid>
    )
  })
